import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Header from "./components/AdminHeader";
import { exportTableToPDF } from "./utils/exportPDF";

const ExpenditureKitchenDetails2 = () => {
  const id = localStorage.getItem("get_kitchen_id_exp");

  const [requisitionList, setRequisitionList] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [editedStockName, setEditedStockName] = useState("");
  const [editedQuantity, setEditedQuantity] = useState("");
  const [editedDate, setEditedDate] = useState("");
  const [editedId, setEditedId] = useState("");

  const itemsPerPage = 10;

  useEffect(() => {
    fetchRequisitionList();
  }, []);

  const fetchRequisitionList = async (startDate = "", endDate = "") => {
    let url = `https://ims-backend.indevconsultancy.in/api/daily-expendituress/${id}/`;

    const params = new URLSearchParams();
    if (startDate) params.append("start_date", startDate);
    if (endDate) params.append("end_date", endDate);

    if (params.toString()) {
      url += `?${params.toString()}`;
    }

    try {
      const res = await axios.get(url);
      if (res.data) {
        setRequisitionList(res.data);
        setCurrentPage(1);
      }
    } catch (err) {
      console.error("Failed to fetch requisition list:", err);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    fetchRequisitionList(startDate, endDate);
  };

  const exportToCSV = () => {
    if (!filteredList.length) return;

    const headers = ["S.No.", "Stock Name", "Quantity", "Expenditure Date"];
    const rows = filteredList.map((item, index) => {
      const date = new Date(item.created_at);
      const formattedDate = `${date.getDate().toString().padStart(2, "0")}-${(
        date.getMonth() + 1
      )
        .toString()
        .padStart(2, "0")}-${date.getFullYear()}`;
      return [
        index + 1,
        `${item.stock_name} (${item.units})`,
        item.expenditure_quantity,
        formattedDate,
      ];
    });

    const csvContent =
      "data:text/csv;charset=utf-8," +
      [headers.join(","), ...rows.map((r) => r.join(","))].join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "filtered_kitchen_expenditure.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const exportToPDF = () => {
    const headers = ["S.No.", "Stock Name", "Quantity", "Expenditure Date"];
    const rows = filteredList.map((item, index) => {
      const date = new Date(item.created_at);
      const formattedDate = `${date.getDate().toString().padStart(2, "0")}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${date.getFullYear()}`;
      return [index + 1, `${item.stock_name} (${item.units})`, item.expenditure_quantity, formattedDate];
    });
    exportTableToPDF({
      title: "Kitchen Expenditure Report",
      headers,
      rows,
      filename: "filtered_kitchen_expenditure.pdf",
      filterInfo: `Total: ${rows.length}`,
    });
  };

  // Filter by stock name
  const filteredList = requisitionList.filter((item) =>
    item.stock_name.toLowerCase().includes(searchKeyword.toLowerCase())
  );

  // Pagination after filtering
  const paginatedList = filteredList.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  const totalPages = Math.ceil(filteredList.length / itemsPerPage);

  return (
    <>
      <Header />
      <div className="container-fluid px-2">
        <div className="row align-items-center justify-content-between py-2">
          <div className="col-md-6 col-6">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb justify-content-start mb-0">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Home</Link>
                </li>
              </ol>
            </nav>
          </div>
          <div className="col-md-6 col-6 text-end">
            <span className="fs-1">Kitchen View</span>
          </div>
        </div>

        <div className="card">
          <div className="card-header border-info">
            <form onSubmit={handleSearch}>
              <div className="row g-3">
                <div className="col-lg">
                  <input
                    type="date"
                    className="form-control"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    placeholder="Start Date"
                  />
                </div>

                <div className="col-lg">
                  <input
                    type="date"
                    className="form-control"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    placeholder="End Date"
                  />
                </div>

                <div className="col-lg">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search Stock Name"
                    value={searchKeyword}
                    onChange={(e) => setSearchKeyword(e.target.value)}
                  />
                </div>

                <div className="col-lg-2">
                  <button type="submit" className="btn btn-primary w-100">
                    Search
                  </button>
                </div>

                <div className="col-lg-1">
                  <button
                    type="button"
                    className="btn btn-outline-dark w-100"
                    onClick={() => {
                      setStartDate("");
                      setEndDate("");
                      setSearchKeyword("");
                      fetchRequisitionList();
                    }}
                  >
                    Reset
                  </button>
                </div>
              </div>
            </form>
          </div>

          <div className="card-body">
            <div className="row g-0 align-items-center">
              <div className="d-flex justify-content-between">
                <h6 className="fw-bold mb-0">
                  Total Item(s): <span>{filteredList.length}</span>
                </h6>
                <button
                  className="btn btn-primary btn-sm mb-1"
                  onClick={exportToCSV}
                >
                  <i className="fas fa-file me-1"></i>
                  Export
                </button>
                 <button
                    className="btn btn-danger btn-sm mb-1"
                    onClick={exportToPDF}
                  >
                    <i className="fas fa-file-pdf me-1"></i>
                    Export PDF
                  </button>
              </div>
            </div>

            <div className="table-responsive scrollbar">
              <table className="table text-center table-bordered table-striped fs--1 mb-0">
                <thead className="bg-primary text-white">
                  <tr>
                    <th>S.No.</th>
                    <th>Stock Name</th>
                    <th>Quantity</th>
                    <th>Expenditure Date</th>
                    {/* <th>Action</th> */}
                  </tr>
                </thead>
                <tbody>
                  {paginatedList.length === 0 ? (
                    <tr>
                      <td colSpan="4" className="text-center">
                        Loading or no data available
                      </td>
                    </tr>
                  ) : (
                    paginatedList.map((item, index) => (
                      <tr key={index}>
                        <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                        <td>
                          {item.stock_name} ({item.units})
                        </td>
                        <td>{item.expenditure_quantity}</td>
                        <td>
                          {(() => {
                            const d = new Date(item.created_at);
                            return `${d
                              .getDate()
                              .toString()
                              .padStart(2, "0")}-${(d.getMonth() + 1)
                                .toString()
                                .padStart(2, "0")}-${d.getFullYear()}`;
                          })()}
                        </td>
                        {/* <td>
                          <button
                            className="btn btn-sm me-1 text-white"
                             style={{background:"#28a745"}}
                            onClick={() => {
                              if (!item.dailyexpenditure_id) {
                                alert("No ID found for this item.");
                                return;
                              }

                              setEditedId(item.dailyexpenditure_id);
                              setEditedStockName(item.stock_name);
                              setEditedQuantity(item.expenditure_quantity);
                              setEditedDate(item.created_at?.slice(0, 10));
                              setShowModal(true);
                            }}
                          >
                            Edit
                          </button>

                          <button
                            className="btn btn-sm text-white"
                           style={{background:"#8b1a1a"}}
                            onClick={async () => {
                              if (
                                window.confirm(
                                  "Are you sure you want to delete this stock?"
                                )
                              ) {
                                try {
                                  await axios.delete(
                                    `https://ims-backend.indevconsultancy.in/api/daily-expenditures/${item.dailyexpenditure_id}/`
                                  );

                                  fetchRequisitionList(); // Refresh list after delete
                                } catch (err) {
                                  console.error("Delete failed", err);
                                }
                              }
                            }}
                          >
                            Delete
                          </button>
                        </td> */}
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            <div className="d-flex justify-content-between align-items-center mt-3">
              <button
                className="btn btn-outline-primary btn-sm"
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
              >
                Previous
              </button>
              <span>
                Page {currentPage} of {totalPages}
              </span>
              <button
                className="btn btn-outline-primary btn-sm"
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* {showModal && (
        <div className="modal show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Stock</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
            <label className="form-label">ID</label>
            <input
              type="text"
              className="form-control"
              value={editedId}
              readOnly
            />
          </div>
                <div className="mb-3">
                  <label className="form-label">Stock Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={editedStockName}
                    onChange={(e) => setEditedStockName(e.target.value)}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Quantity</label>
                  <input
                    type="number"
                    className="form-control"
                    value={editedQuantity}
                    onChange={(e) => setEditedQuantity(e.target.value)}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Expenditure Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={editedDate}
                    onChange={(e) => setEditedDate(e.target.value)}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={async () => {
                    try {
                      await axios.put(
                        `https://ims-backend.indevconsultancy.in/api/daily-expendituress/${editedId}/`,
                        {
                          stock_name: editedStockName,
                          expenditure_quantity: editedQuantity,
                          created_at: editedDate,
                        }
                      );
                      setShowModal(false);
                      fetchRequisitionList();
                    } catch (err) {
                      console.error("Update failed", err);
                    }
                  }}
                >
                  Save Changes
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )} */}
    </>
  );
};

export default ExpenditureKitchenDetails2;
